export function getNormalizedDay(day: number) {
  return (day + 1) % 7;
}
